import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductOrCategoryPageContent"] */ "/vercel/path0/src/components/PageContent/ProductOrCategoryPageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SharedContext"] */ "/vercel/path0/src/components/SharedContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomURLModal"] */ "/vercel/path0/src/components/URLModal/URLModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["availableFlags"] */ "/vercel/path0/src/lib/featureFlags.ts");
;
import(/* webpackMode: "eager", webpackExports: ["SectionRenderer"] */ "/vercel/path0/src/sections/SectionRenderer.tsx");
